import { FormikConsumer, Field } from 'formik';
import classNames from 'classnames';
import FormControl from './FormControl';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class Checkboxes extends Component {
  constructor(props) {
    super(props);

    this.checkAll = this.checkAll.bind(this);
  }

  checkAll = (event) => {
    let value = this.props.value;

    if (event.target.checked) {
      for (let i = 0; i < this.props.options.length; i++) {
        if (!this.props.value.includes(this.props.options[i].value)) {
          value.push(this.props.options[i].value);
        }
      }
    } else {
      value = [];
    }
  };

  renderOptions = () => {
    return (
      this.props.options.map((item, index) =>
        <div className={classNames(['usa-checkbox', this.props.value.includes(item.value) ? 'checked' : ''])}
          key={index}>
          <Field
            type="checkbox"
            value={item.value}
            name={this.props.name}
            id={this.props.name + '_' + item.value} />
          <label htmlFor={this.props.name + '_' + item.value}>{item.label}</label>
        </div>
      )
    )
  };

  render() {
    return (
      <FormikConsumer>
        {({ errors, touched }) => (
          <FormControl
            label={this.props.label}
            hasError={this.props.hasError}
            className={classNames(
              'form-checkboxes',
              'usa-checkboxes',
              this.props.className,
            )}
            showThrobber={this.props.showThrobber}
            name={this.props.name}>
            <div className="check-all">
              <label><input type="checkbox" onChange={this.checkAll} /> Select all</label>
            </div>
            {this.renderOptions()}
          </FormControl>
        )}
      </FormikConsumer>
    )
  }
}

Checkboxes.defaultProps = {
  className: [],
  options: [],
  validations: [],
  label: '',
  value: [],
  mapped: false
};

Checkboxes.propTypes = {
  className: PropTypes.array,
  options: PropTypes.array,
  validations: PropTypes.array,
  label: PropTypes.string,
  value: PropTypes.array,
  mapped: PropTypes.bool
};

export default Checkboxes;
